import React from 'react';
import './addon-shop.css';
import { useTranslation } from 'react-i18next';

export default function AddonCard({
  id,
  name,
  price,
  icon,
  gradient,
  description,
  benefits,
  badge,      // 'included' | 'pro-only' | null
  disabled,   // true para Exclusivo Pro en plan Starter
  selected,   // true si este radio está seleccionado
  onSelect    // (id) => void
}) {
  const { t } = useTranslation('addons');

  const handleClick = () => {
    if (!disabled) {
      onSelect(id);
    }
  };

  return (
    <div
      className={`addon-card ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
    >
      {badge && (
        <span className={`badge badge-${badge}`}>
          {badge === 'included' ? t('badges.included') : badge === 'canceling' ? t('badges.canceling') : t('badges.proOnly')}
        </span>
      )}

      <div className="card-image" style={{ background: gradient }}>
        <span className="icon-large">{icon}</span>
      </div>

      <h3 className="card-title">{name}</h3>
      <div className="card-price">
        ${price}
        <span className="price-period">{t('card.perMonth')}</span>
      </div>

      <p className="card-description">{description}</p>

      <ul className="card-benefits">
        {benefits.map((benefit, idx) => (
          <li key={idx}>✓ {benefit}</li>
        ))}
      </ul>

      <label className="radio-label" onClick={(e) => e.stopPropagation()}>
        <input
          type="radio"
          name="addon-selection"
          checked={selected}
          onChange={() => onSelect(id)}
          disabled={disabled}
        />
        <span className="radio-text">{t('card.select')}</span>
      </label>
    </div>
  );
}
